const config = (window as any).haciendaConfig ?? {};
export const environment = {
  production: false,
  version: '1.0.0',
  servidorApiUrl: '',
  servidorReportesUrl: config.reportesUrl ?? '',
  aplicacionId: 1
};
